module.exports = __webpack_public_path__ + "assets/images/info.svg";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/info.svg
// module id = 497
// module chunks = 0